import axios from '@/jslib/axios'

export const login = data => {
  return axios({
    method: 'post',
    url: '/api/login',
    data
  })
}

export const logout = () => {
  return axios({
    method: 'get',
    url: '/api/logout'
  })
}

export const getUserInfo = () => {
  return axios({
    method: 'get',
    url: '/api/userinfo'
  })
}

export const getAllOptions = params => {
  return axios({
    method: 'get',
    url: '/api/options',
    params
  })
}

export const getPolicyList = params => {
  return axios({
    method: 'get',
    url: '/api/policy',
    params
  })
}

export const createPolicy = data => {
  return axios({
    method: 'post',
    url: '/api/policy',
    data
  })
}

export const getPolicyData = policyId => {
  return axios({
    method: 'get',
    url: `/api/policy/${policyId}/data`
  })
}

export const updatePolicy = (policyId, data) => {
  return axios({
    method: 'put',
    url: `/api/policy/${policyId}`,
    data
  })
}

export const downloadPolicy = params => {
  return axios({
    method: 'get',
    url: '/api/policy/download',
    params,
    responseType: 'blob'
  })
}

export const lockInBatch = params => {
  return axios({
    method: 'put',
    url: '/api/policy/lock_in_batch',
    params
  })
}

export const exportPolicy = params => {
  return axios({
    method: 'get',
    url: '/api/policy/export',
    params,
    responseType: ['blob']
  })
}

export const setPolicyStatus = data => {
  return axios({
    method: 'post',
    url: `/api/policy/${data.policy_id}/status`,
    data
  })
}